/*
 * @Description: 
 * @Autor: yd
 * @Date: 2020-08-17 11:00:19
 * @LastEditors: yd
 * @LastEditTime: 2020-09-25 09:40:55
 */
//组织机构变更
import http from '../httpConfig'

const table = "mrbase_sys_org_levels_change"


export const getOrganizationalManagementList = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/dept/list-change/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

export const detailOrganizationalManagement = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/dept/find-change/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

export const deleteOrganizationalManagement = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/dept/delete-change/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}


export const updateOrganizationalManagement = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/dept/update-change/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}


export const addOrganizationalManagement = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/dept/add-change/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
